'use strict';
import isArray from 'lodash/isArray';
import isFunction from 'lodash/isFunction';
import isObject from 'lodash/isObject';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/timer';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mapTo';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/take';
import {convertToExcel} from '../csv-imports-exports/ExcelUtils';
import {ReportFormat} from '../enums/ReportFormat';
import {RequestStatus} from '../enums/RequestStatus';
import {epicErrorHandler} from '../rx-utils';
import {AbstractEpics} from '../redux/AbstractEpics';


/**
 * Exported for unit testing
 */
export class ReduxObservableListExportsEpics extends AbstractEpics {
  /**
   * @param {ReduxObservableListExportsActions} actions
   * @param {ReduxObservableListExportsOptions} options
   */
  constructor(actions, options) {
    super(options);

    /** @type {ReduxObservableListExportsActions} **/
    this.actions = actions;
    /** @param {ReduxObservableListExportsOptions} */
    this.options = options;

    this.onRequestSuccess = this.onRequestSuccess.bind(this);
    this.addEpic(this.onRequestSuccess);

    this.onRequestSuccess.$inject = [
      '$download',
    ];
  }

  /**
   * @param {ActionsObservable<ReduxAction>} action$
   * @param {Store} store
   * @param dependencies
   */
  onRequestSuccess(action$, store, dependencies) {
    return action$.ofType(this.actions.requestSuccess.TYPE)
      .switchMap(action => {
        if (action.payload.status === RequestStatus.NO_RESULTS) {
          return Observable.timer(this.options.modalCloseDelay)
            .take(1)
            .mapTo(this.actions.hideModal());
        } else {
          const request = action.payload.request;
          const ajaxResponse = action.payload.ajaxResponse;

          if (request.format === ReportFormat.CSV) {
            dependencies.$download.downloadBlob(ajaxResponse.response, `${this.options.getFileName(request)}.csv`);
          } else if (request.format === ReportFormat.XLSX
            && isObject(ajaxResponse.response)
            && isArray(ajaxResponse.response.list)
          ) {
            if (isFunction(this.options.modifyResponse)) {
              this.options.modifyResponse(ajaxResponse);
            }

            const blob = convertToExcel(ajaxResponse.response);

            if (blob) {
              dependencies.$download.downloadBlob(blob, `${this.options.getFileName(request)}.xlsx`);
            }
          }
          return Observable.of(this.actions.hideModal());
        }
      })
      .catch(epicErrorHandler(this.logger, 'onRequestSuccess'));
  }
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/redux-observable-list-exports/epics.js